/**
 * DY wishlist placeholder accessibility.
 * Wrappers are decorative placeholders; injected <wishlist-button> is the control.
 */
(() => {
  'use strict';

  const WRAPPER_SELECTOR = '.wishlist-dy-icon-wrapper';

  const markHidden = (el) => {
    if (el?.matches?.(WRAPPER_SELECTOR) && !el.querySelector('wishlist-button')) {
      el.setAttribute('aria-hidden', 'true');
    }
  };

  const applyInSubtree = (root) => {
    if (!root || root.nodeType !== 1) return;
    markHidden(root);
    root.querySelectorAll?.(WRAPPER_SELECTOR).forEach(markHidden);
  };

  const init = () => {
    applyInSubtree(document.body);

    const onDyDomChange = () => {
      document.querySelectorAll(WRAPPER_SELECTOR).forEach((wrapper) => {
        if (wrapper.querySelector('wishlist-button')) {
          wrapper.setAttribute('aria-hidden', 'false');
        } else {
          markHidden(wrapper);
        }
      });
    };

    document.addEventListener('wishlist:updated', onDyDomChange);

    if (window.MutationObserver && document.body) {
      let debounceTimer = null;
      const observer = new MutationObserver(() => {
        if (debounceTimer) return;
        debounceTimer = window.setTimeout(() => {
          debounceTimer = null;
          onDyDomChange();
        }, 200);
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
